module.exports = __webpack_public_path__ + "img/aizp.f8a3bd7d.jpg";